module.exports = __webpack_public_path__ + "static/img/C (18).3aef8870.png";